import { AccountTypeEnum } from '../api/account-type-enum'

interface RouteValue {
  path: string
  isProtected?: boolean
  backPath?: string
}

const routes = {
  HOME: {
    path: '',
  },
  INVESTMENTS_ACCOUNT_OWNERSHIP: {
    path: 'investments/account-ownership/',
  },
  INVESTMENTS_INTRO: {
    path: 'investments/intro/',
  },
  INVESTMENTS_ACCOUNT_SELECTION: {
    path: 'investments/account-selection/',
  },
  INVESTMENTS_GET_STARTED: {
    path: 'investments/get-started/:accountType/',
  },
  INVESTMENTS_ACCOUNT_NAME: {
    path: 'investments/account-name/:accountType/',
  },
  INVESTMENTS_PERSONAL_INFO: {
    path: 'investments/personal-info/:accountType/',
  },
  INVESTMENTS_SUITABILITY: {
    path: 'investments/suitability/:accountType/',
  },
  INVESTMENTS_WELCOME: {
    path: 'investments/:accountType/welcome/',
  },
  INVESTMENTS_FILING_STATUS: {
    path: 'investments/filing-status/:accountType/',
  },
  INVESTMENTS_INVESTMENT_GOALS: {
    path: 'investments/investment-goals/:accountType/',
  },
  INVESTMENTS_DISCLOSURES_BROKERAGE: {
    path: `investments/${AccountTypeEnum.BROKERAGE}/disclosures/`,
  },
  INVESTMENTS_DISCLOSURES_IRA: {
    path: `investments/${AccountTypeEnum.TRADITIONAL}/disclosures/`,
  },
  INVESTMENTS_DISCLOSURES_ROTH: {
    path: `investments/${AccountTypeEnum.ROTH}/disclosures/`,
  },
  INVESTMENTS_DISCLOSURES_ROTH_INHERITED: {
    path: `investments/${AccountTypeEnum.ROTH_INHERITED}/disclosures/`,
  },
  INVESTMENTS_DISCLOSURES_TRADITIONAL_INHERITED: {
    path: `investments/${AccountTypeEnum.TRADITIONAL_INHERITED}/disclosures/`,
  },
  INVESTMENTS_EQUITY: {
    path: 'investments/equity/:accountType/',
  },
  INVESTMENTS_RISK_RETURN: {
    path: 'investments/risk-return/:accountType/',
  },
  INVESTMENTS_PERSONALIZATION_COMPLETE: {
    path: 'investments/personalization-complete/:accountType/',
  },
  INVESTMENTS_CASH_EQUIVALENT: {
    path: 'investments/cash-equivalent/:accountType/',
  },
  INVESTMENTS_FIXED_INCOME: {
    path: 'investments/fixed-income/:accountType/',
  },
  INVESTMENTS_LOADING: {
    path: 'investments/loading/:accountType/',
  },
  INVESTMENTS_PORTFOLIO_SETTINGS_OVERVIEW: {
    path: 'investments/portfolio-settings-overview/:accountType/',
  },
  INVESTMENTS_PORTFOLIO_SETTINGS: {
    path: 'investments/portfolio-settings/:accountType/',
  },
  INVESTMENTS_WELCOME_COMPANION: {
    path: 'investments/:accountType/companion/welcome',
  },
  INVESTMENTS_DISCLOSURES_COMPANION_BROKERAGE: {
    path: `investments/${AccountTypeEnum.BROKERAGE}/companion/disclosures`,
  },
  INVESTMENTS_DISCLOSURES_COMPANION_IRA: {
    path: `investments/${AccountTypeEnum.TRADITIONAL}/companion/disclosures`,
  },
  INVESTMENTS_DISCLOSURES_COMPANION_ROTH: {
    path: `investments/${AccountTypeEnum.ROTH}/companion/disclosures`,
  },
  INVESTMENTS_INTRO_COMPANION: {
    path: 'investments/:accountType/companion/intro',
  },
  CONFIRM_INFORMATION_V2: {
    path: 'investments/confirm-information/:accountType/',
    isProtected: true,
  },
  //INTEGRATION:EnrollmentConst
} as const

// Record<string, RouteValue> doesn't suggest Route, so we need to define the following types to have keys suggested by TypeScript
type Routes = typeof routes
type RouteKey = keyof Routes
type Route = Record<RouteKey, RouteValue>
export const ROUTES = routes as Route
